import * as React from 'react';

import { getServerTranslations } from '../../../get-server-side-translations';
import ProductDescription from '../../../components/product-description';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IProductDescriptionProps {}

const ProductDescriptionPage: React.FunctionComponent<IProductDescriptionProps> = (props) => (
  <ProductDescription {...props} />
);

export default ProductDescriptionPage;
export const getStaticProps = async ({ locale }) => {
  const transConfig = await getServerTranslations(locale, ['common', 'product-description-page']);
  return {
    props: {
      ...transConfig,
    },
  };
};
